import appDownloadActionKeys from './appDownloadActionKeys';
import * as service from '../eventService';

// eslint-disable-next-line max-len
const sendAppLink = (os: string, contactNumber: string, platformType?: string, referrer?: string) => ({
  type: appDownloadActionKeys.SEND_APP_LINK,
  payload: service.sendAppLink({
    os,
    contactNumber,
    platformType,
    referrer,
  }),
});

/* eslint-disable import/prefer-default-export */
export { sendAppLink };



// WEBPACK FOOTER //
// ./src/app/common/download/appDownloadActions.js